{#if $isUserLoggedIn}
<div class="search-page">
  <Search></Search>
</div>
{:else}
<HiddenFromSSR>
  <FreeTextLayout>
    <h1>Search</h1>

    <p>You can search once logged in to an instance.</p>
  </FreeTextLayout>
</HiddenFromSSR>
<div style="display: none">
  <!-- TODO: this is just a hack so that `sapper export` knows to crawl these files -->
  <!-- Note that these links have to be spread out or else they result in ECONNRESET errors during crawling -->
  <!-- See also community/index.html -->
  <a href="/local">Local</a>
  <a href="/federated">Federated</a>
  <a href="/favorites">Favorites</a>
  <a href="/direct">Direct messages</a>
  <a href="/bookmarks">Bookmarks</a>
</div>
{/if}
<style>
  .search-page {
    padding: 20px 20px;
  }

  @media (max-width: 767px) {
    .search-page {
      padding: 20px 10px;
    }
  }
</style>
<script>
  import FreeTextLayout from '../_components/FreeTextLayout.html'
  import { store } from '../_store/store.js'
  import HiddenFromSSR from '../_components/HiddenFromSSR.html'
  import Search from '../_components/search/Search.html'

  export default {
    store: () => store,
    components: {
      Search,
      FreeTextLayout,
      HiddenFromSSR
    }
  }
</script>
